// import { debounceAxios } from "../controller/DebounceAxios";
import axios from 'axios';

const paramsSerializer = (params) => {
    return Object.entries(Object.assign({}, params))
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
};

const nominatimSearch = async (searchString, signal) => {
    const config = {
        url: 'https://nominatim.openstreetmap.org/search',
        signal,
        paramsSerializer,
        params: {
            format: 'json',
            countrycodes: 'US',
            q: searchString,
            limit: 10
        }
    };
    return searchLookup(config);
};
export { nominatimSearch };

const nominatimSearchStreet = async (searchString, signal) => {
    const config = {
        url: 'https://nominatim.openstreetmap.org/search',
        signal,
        paramsSerializer,
        params: {
            format: 'json',
            countrycodes: 'US',
            street: searchString,
            limit: 1
        }
    };
    return searchLookup(config);
};
export { nominatimSearchStreet };

const nominatimLookup = async (id, type, signal) => {
    const config = {
        url: 'https://nominatim.openstreetmap.org/lookup',
        signal,
        paramsSerializer,
        params: {
            format: 'json',
            osm_ids: type.substring(0, 1) + id
        }
    };
    return axios(config).then((res) => {
        return res.data?.[0];
    });
};
export { nominatimLookup };

const photonSearch = async (searchString, boundingbox, signal) => {
    const config = {
        url: 'https://photon.komoot.io/api/',
        signal,
        paramsSerializer,
        params: {
            q: searchString,
            bbox: boundingbox.join(','),
            // osm_tag: "place:state",
            osm_tag: '!amenity&osm_tag=!convenience&osm_tag=!natural',
            limit: 10
        }
    };
    //https://photon.komoot.io/api/?q=walm&bbox=-172.96875,14.604847,-60.117188,72.711903&osm_tag=!amenity&osm_tag=!natural&limit=10
    return axios(config).then((res) => {
        return res.data;
    });
};
export { photonSearch };

const mapboxSearch = async (searchString, boundingbox, signal) => {
    const config = {
        url: `https://api.mapbox.com/geocoding/v5/mapbox.places/${searchString}.json`,
        signal,
        paramsSerializer,
        params: {
            country: 'us',
            proximity: 'ip',
            autocomplete: true,
            types: 'place%2Cpostcode%2Caddress',
            access_token: 'pk.eyJ1IjoicXlwMyIsImEiOiJjbGJ2M3MzbTAwNTNxM25yOXh1ZHAyeGhsIn0.ha-q25qjBmsPVAsAMsa8RA'
        }
    };
    if (boundingbox) {
        config.params.bbox = boundingbox.join('%2C');
        config.params.limit = 10;
    }
    return axios(config).then((res) => {
        return res.data;
    });
};

/**
 *GET 
 /geocoding/v5/mapbox.places/au.json?country=us&proximity=ip&types=place%2Cpostcode%2Caddress&access_token=pk.eyJ1IjoicXlwMyIsImEiOiJjbGJ2M3MzbTAwNTNxM25yOXh1ZHAyeGhsIn0.ha-q25qjBmsPVAsAMsa8RA HTTP/1.1

 */
export { mapboxSearch };

const searchLookup = async (config) => {
    if (!config.params.q && !config.params.street) return [];

    return axios(config).then((res) => {
        return res.data;
    });
};
export { searchLookup };
